export default __webpack_public_path__ + "static/media/howto_5.b94f5a7d.png";